import * as _ from 'lodash';
import { ADD_EXPENSES, SET_CURRENCY_VIEW, UPDATE_EXPENSE } from '@Actions/expenseListActions';
export const defaultState = {
    expenses: [],
    currencyView: 'Home Currency'
};
export const expenseListReducer = function (state = defaultState, action) {
    function uniq(expenses) {
        return _.uniqBy(expenses, (expense) => expense.id);
    }
    switch (action.type) {
        case ADD_EXPENSES:
            return _.assign({}, state, {
                expenses: uniq([...action.expenses, ...state.expenses])
            });
        case UPDATE_EXPENSE: {
            const updatedExpenses = state.expenses.map((expense) => {
                if (expense.id === action.expense.id) {
                    return Object.assign(Object.assign({}, expense), action.expense);
                }
                return expense;
            });
            return Object.assign(Object.assign({}, state), { expenses: updatedExpenses });
        }
        case SET_CURRENCY_VIEW: {
            return Object.assign(Object.assign({}, state), { currencyView: action.currencyView });
        }
        default:
            return state;
    }
};
